import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { K8sRegistryAccessNotice } from '@/react/kubernetes/components/K8sRegistryAccessNotice';

import { FormSection } from '@@/form-components/FormSection';
import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';
import { PortainerSelect } from '@@/form-components/PortainerSelect';

interface Props {
  namespace: string;
  name: string;
  namespaces: Array<{ label: string; value: string }>;
  isNamespaceDisabled?: boolean;
  errors?: {
    namespace?: string;
    name?: string;
  };
  onNamespaceChange: (value: string) => void;
  onNameChange: (value: string) => void;
}

export function HelmDeployToSection({
  namespace,
  name,
  namespaces,
  isNamespaceDisabled,
  errors,
  onNamespaceChange,
  onNameChange,
}: Props) {
  const environmentId = useEnvironmentId();

  return (
    <FormSection title="Deploy to">
      <FormControl label="Namespace" required errors={errors?.namespace}>
        <div className="mb-1">
          <K8sRegistryAccessNotice
            namespace={namespace}
            environmentId={environmentId}
          />
        </div>
        <PortainerSelect
          value={namespace}
          onChange={onNamespaceChange}
          options={namespaces}
          disabled={isNamespaceDisabled}
          data-cy="namespace-select"
        />
      </FormControl>

      <FormControl label="Release name" required errors={errors?.name}>
        <Input
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="e.g. my-app"
          data-cy="k8sHelmInstall-nameInput"
        />
      </FormControl>
    </FormSection>
  );
}
